webpackJsonp([4],{

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(38);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(212);

var _reactStatic = __webpack_require__(91);

var _utils = __webpack_require__(64);

var _actions = __webpack_require__(596);

var _Trackable = __webpack_require__(594);

var _Trackable2 = _interopRequireDefault(_Trackable);

var _MetaTags = __webpack_require__(595);

var _MetaTags2 = _interopRequireDefault(_MetaTags);

var _DocLink = __webpack_require__(677);

var _DocLink2 = _interopRequireDefault(_DocLink);

var _HeroProvider = __webpack_require__(678);

var _HeroProvider2 = _interopRequireDefault(_HeroProvider);

var _ProviderAsAPICard = __webpack_require__(627);

var _ProviderAsAPICard2 = _interopRequireDefault(_ProviderAsAPICard);

var _ProviderCapabilities = __webpack_require__(679);

var _ProviderCapabilities2 = _interopRequireDefault(_ProviderCapabilities);

var _LegacyInfo = __webpack_require__(680);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Provider = function (_React$Component) {
    _inherits(Provider, _React$Component);

    function Provider() {
        _classCallCheck(this, Provider);

        return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
    }

    _createClass(Provider, [{
        key: 'componentDidMount',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
                var _props, slug, dispatch, providersFromAPI, apidocsFromElastic, res, _ref2, _ref2$intents, intents, _ref2$instances, instances, providers;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _props = this.props, slug = _props.slug, dispatch = _props.dispatch, providersFromAPI = _props.providersFromAPI, apidocsFromElastic = _props.apidocsFromElastic;
                                _context.next = 3;
                                return (0, _actions.apidocsFromElasticAction)({ slug: slug })(dispatch, apidocsFromElastic);

                            case 3:
                                res = _context.sent;

                                if (!providersFromAPI[slug]) {
                                    _context.next = 6;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 6:
                                _context.prev = 6;
                                _ref2 = res.response.data.results || {}, _ref2$intents = _ref2.intents, intents = _ref2$intents === undefined ? [] : _ref2$intents, _ref2$instances = _ref2.instances, instances = _ref2$instances === undefined ? {} : _ref2$instances;
                                providers = intents.map(function (intent) {
                                    return {
                                        intent: intent,
                                        id: instances[intent].id
                                    };
                                });
                                _context.next = 11;
                                return (0, _actions.providersFromAPIAction)({ providers: providers, slug: slug })(dispatch);

                            case 11:
                                _context.next = 16;
                                break;

                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context['catch'](6);

                                (0, _utils.track)('UI Error', { message: _context.t0, response: res });

                            case 16:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[6, 13]]);
            }));

            function componentDidMount() {
                return _ref.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                slug = _props2.slug,
                prefetchedIntents = _props2.prefetchedIntents,
                prefetchedFirstIntent = _props2.prefetchedFirstIntent,
                prefetchedLogo = _props2.prefetchedLogo,
                apidocsFromElastic = _props2.apidocsFromElastic;

            var _ref3 = apidocsFromElastic[slug] || {},
                _ref3$results = _ref3.results,
                results = _ref3$results === undefined ? {} : _ref3$results,
                pending = _ref3.pending;

            var apidoc = results.apidoc,
                _results$intents = results.intents,
                intents = _results$intents === undefined ? [] : _results$intents;


            if (!apidoc || !apidoc.name) {
                var _prefetchedFirstInten = prefetchedFirstIntent.vendor,
                    _vendor = _prefetchedFirstInten === undefined ? '' : _prefetchedFirstInten,
                    _prefetchedFirstInten2 = prefetchedFirstIntent.name,
                    _name = _prefetchedFirstInten2 === undefined ? '' : _prefetchedFirstInten2,
                    picture = prefetchedFirstIntent.picture,
                    _logo = prefetchedFirstIntent.logo,
                    _prefetchedFirstInten3 = prefetchedFirstIntent.description,
                    _description = _prefetchedFirstInten3 === undefined ? '' : _prefetchedFirstInten3;

                apidoc = {
                    vendor: _vendor,
                    name: _name.replace(_vendor + ' ', '') || _description,
                    version: '',
                    description: _description,
                    links: [],
                    image_url: picture,
                    logo: _logo
                };
                intents = prefetchedIntents.map(function (a) {
                    return a.intent;
                });
                // console.log(slug, apidoc, apidocsFromElastic[slug]);
            }
            var _apidoc = apidoc,
                vendor = _apidoc.vendor,
                name = _apidoc.name,
                version = _apidoc.version,
                description = _apidoc.description,
                links = _apidoc.links,
                image_url = _apidoc.image_url,
                logo = _apidoc.logo,
                id = _apidoc.id;


            var title = (vendor || '') + ' ' + name + ' ' + version;
            var metatags = {
                title: title,
                description: title,
                og: {
                    title: title,
                    description: title,
                    url: 'https://inten.to/api-platform/api/' + slug,
                    image: prefetchedLogo,
                    imageHeight: 200,
                    imageWidth: 200
                },
                twitter: {
                    title: title,
                    description: title,
                    image: prefetchedLogo
                }
            };

            var related = results.related;


            var logoSrc = image_url ? '/' + image_url : logo.replace('https://inten.to', '');

            var relatedAPIs = null;

            if ((related || []).length > 1) {
                relatedAPIs = _react2.default.createElement(
                    'div',
                    { className: 'doc__section animate-appear' },
                    _react2.default.createElement(
                        'div',
                        { className: 'doc__title h2' },
                        'Related APIs'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'catalog__results' },
                        _react2.default.createElement(
                            'div',
                            { className: 'api-cards' },
                            _react2.default.createElement(
                                'div',
                                { className: 'api-cards__list' },
                                related.sort((0, _utils.sortByKey)('vendor')).map(function (provider) {
                                    return _react2.default.createElement(_ProviderAsAPICard2.default, {
                                        noModels: true,
                                        key: provider.id,
                                        provider: _extends({}, provider, {
                                            api_id: provider.id,
                                            description: provider.name,
                                            picture: provider.image_url
                                        })
                                    });
                                })
                            )
                        )
                    )
                );
            }

            return _react2.default.createElement(
                _Trackable2.default,
                { page: 'provider' },
                _react2.default.createElement(_MetaTags2.default, { tags: metatags }),
                _react2.default.createElement(_HeroProvider2.default, { apidoc: apidoc, intents: intents }),
                _react2.default.createElement(
                    'section',
                    { className: 'doc' },
                    _react2.default.createElement(
                        'div',
                        { className: 'doc__container container' },
                        _react2.default.createElement(
                            'div',
                            { className: 'doc__inner' },
                            _react2.default.createElement(
                                'div',
                                { className: 'doc__section' },
                                _react2.default.createElement(_LegacyInfo.LegacyInfo, { providerId: id }),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'doc__desc' },
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'doc__desc-image' },
                                        logoSrc && _react2.default.createElement('img', {
                                            className: 'animate-appear',
                                            src: logoSrc,
                                            alt: 'Logo'
                                        })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: 'doc__desc-content' },
                                        pending && !description && _react2.default.createElement(
                                            'p',
                                            { style: { opacity: 0.5 } },
                                            'Loading...'
                                        ),
                                        (description || !pending) && _react2.default.createElement(
                                            'p',
                                            { className: 'animate-appear' },
                                            description || ''
                                        )
                                    )
                                )
                            ),
                            _react2.default.createElement(_ProviderCapabilities2.default, null),
                            (links || []).length > 1 && _react2.default.createElement(
                                'div',
                                { className: 'doc__section animate-appear' },
                                _react2.default.createElement(
                                    'div',
                                    { className: 'doc__title h2' },
                                    'Links'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: 'doc__links' },
                                    _react2.default.createElement(
                                        'ul',
                                        { className: 'resource-links' },
                                        links.sort((0, _utils.sortByKeys)('type', 'title')).map(function (link) {
                                            return _react2.default.createElement(_DocLink2.default, _extends({
                                                key: link.id
                                            }, link));
                                        })
                                    )
                                )
                            ),
                            relatedAPIs
                        )
                    )
                )
            );
        }
    }]);

    return Provider;
}(_react2.default.Component);

function mapStateToProps(state) {
    return {
        apidocsFromElastic: state.apidocsFromElastic || {},
        providersFromAPI: state.providersFromAPI || {}
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactStatic.withRouteData)(Provider));

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(592);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeroBase = function HeroBase(_ref) {
    var children = _ref.children,
        cols = _ref.cols,
        center = _ref.center,
        className = _ref.className;
    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames2.default)('hero hero--main hero--gradient-blue ' + (center ? 'hero--center' : ''), className)
        },
        _react2.default.createElement(
            'div',
            { className: 'hero__container container' },
            _react2.default.createElement(
                'div',
                { className: cols ? 'hero__cols' : 'hero__content' },
                children
            )
        )
    );
};

exports.default = HeroBase;

/***/ }),

/***/ 594:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Trackable = function (_React$Component) {
    _inherits(Trackable, _React$Component);

    function Trackable() {
        _classCallCheck(this, Trackable);

        return _possibleConstructorReturn(this, (Trackable.__proto__ || Object.getPrototypeOf(Trackable)).apply(this, arguments));
    }

    _createClass(Trackable, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var page = this.props.page;

            if (!window.userLanded) {
                var params = {
                    page: page,
                    ab_group: (0, _utils.getCookieValue)('ab_group')
                    // locale: i18n.lng()
                };

                (0, _utils.track)('User landed', params, function () {
                    window.userLanded = true;
                    window.ab_group = (0, _utils.getCookieValue)('ab_group');
                });
            }

            // track page open as well, regardless of the initial landing
            (0, _utils.track)('Page opened', {
                page: page
                // locale: i18n.lng()
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                className = _props.className;

            return _react2.default.createElement(
                'main',
                { className: 'content ' + className },
                children
            );
        }
    }]);

    return Trackable;
}(_react2.default.Component);

exports.default = Trackable;

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(91);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// changes here requires dev server to restart
// because this component is used in the site config `static.config.js`

var LOGO = 'https://inten.to/img/brain.png';
var DESCRIPTION = 'Discover, evaluate and use best-of-breed AI. A simple and elegant API to third-party AI models from many vendors.';
var TITLE = 'Intento';

var DEFAULT_TAGS = {
    title: TITLE,
    description: DESCRIPTION,
    logo: LOGO,
    author: 'Intento Inc.',
    twitter: {
        title: TITLE,
        description: DESCRIPTION,
        image: LOGO
    },
    og: {
        title: TITLE,
        site_name: TITLE,
        description: DESCRIPTION,
        image: LOGO,
        imageHeight: 300,
        imageWidth: 300,
        url: 'https://inten.to/'
    }
};

var MetaTags = function MetaTags(props) {
    var _props$tags = props.tags,
        tags = _props$tags === undefined ? DEFAULT_TAGS : _props$tags;

    var meta = _extends({}, DEFAULT_TAGS, tags, {
        description: (tags.description || '') + ' \u2014 ' + DESCRIPTION,
        twitter: _extends({}, DEFAULT_TAGS.twitter, tags.twitter, {
            description: ((tags.twitter || {}).description || '') + ' \u2014 ' + DESCRIPTION
        }),
        og: _extends({}, DEFAULT_TAGS.og, tags.og, {
            description: ((tags.og || {}).description || '') + ' \u2014 ' + DESCRIPTION
        })
    });

    return _react2.default.createElement(
        _reactStatic.Head,
        null,
        _react2.default.createElement(
            'title',
            null,
            meta.title
        ),
        _react2.default.createElement('meta', { name: 'description', content: meta.description }),
        _react2.default.createElement('meta', { name: 'author', content: meta.author }),
        _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
        _react2.default.createElement('meta', { property: 'og:title', content: meta.og.title }),
        _react2.default.createElement('meta', { property: 'og:site_name', content: meta.og.site_name }),
        _react2.default.createElement('meta', { property: 'og:url', content: meta.og.url }),
        _react2.default.createElement('meta', { property: 'og:description', content: meta.og.description }),
        _react2.default.createElement('meta', { property: 'og:image', content: meta.og.image }),
        _react2.default.createElement('meta', { property: 'og:image:height', content: meta.og.imageHeight }),
        _react2.default.createElement('meta', { property: 'og:image:width', content: meta.og.imageWidth }),
        _react2.default.createElement('meta', { name: 'twitter:card', content: 'summary' }),
        _react2.default.createElement('meta', { name: 'twitter:title', content: meta.twitter.title }),
        _react2.default.createElement('meta', {
            name: 'twitter:description',
            content: meta.twitter.description
        }),
        _react2.default.createElement('meta', { name: 'twitter:image', content: meta.twitter.image })
    );
};

exports.default = MetaTags;

/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(38);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.supportSendMessageAction = supportSendMessageAction;
exports.supportResetFormAction = supportResetFormAction;
exports.supportResetStatusAction = supportResetStatusAction;
exports.apidocsFromElasticAction = apidocsFromElasticAction;
exports.providersFromAPIAction = providersFromAPIAction;
exports.getIntentProvidersAction = getIntentProvidersAction;
exports.getIntentLanguagesAction = getIntentLanguagesAction;
exports.catalogSearchParamsAction = catalogSearchParamsAction;
exports.catalogInlineSearchParamsAction = catalogInlineSearchParamsAction;
exports.resetSearchParamsAction = resetSearchParamsAction;
exports.resetDemoParamsOnInputChange = resetDemoParamsOnInputChange;
exports.isPremium = isPremium;
exports.postRequestAPIAction = postRequestAPIAction;
exports.getNews = getNews;

var _constants = __webpack_require__(30);

var _services = __webpack_require__(597);

var _services2 = _interopRequireDefault(_services);

var _utils = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function supportSendMessageAction(data) {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch) {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            dispatch(request());

                            return _context.abrupt('return', _services2.default.support(data).then(function (result) {
                                dispatch(success(result));
                            }, function (error) {
                                dispatch(failure(error));
                            }));

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }();

    function request() {
        (0, _utils.track)('support request', {});
        return { type: _constants.supportConstants.REQUEST };
    }
    function success(data) {
        (0, _utils.track)('support success', {});
        return { type: _constants.supportConstants.SUCCESS, data: data };
    }
    function failure(error) {
        (0, _utils.track)('support failure', {
            reason: error
        });
        return { type: _constants.supportConstants.FAILURE, error: error };
    }
}

function supportResetFormAction() {
    var _this2 = this;

    return function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch) {
            var res;
            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            res = dispatch(request());
                            return _context2.abrupt('return', res);

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }));

        return function (_x2) {
            return _ref2.apply(this, arguments);
        };
    }();

    function request() {
        return { type: _constants.supportConstants.RESET };
    }
}

function supportResetStatusAction() {
    var _this3 = this;

    return function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch) {
            var res;
            return _regenerator2.default.wrap(function _callee3$(_context3) {
                while (1) {
                    switch (_context3.prev = _context3.next) {
                        case 0:
                            res = dispatch(request());
                            return _context3.abrupt('return', res);

                        case 2:
                        case 'end':
                            return _context3.stop();
                    }
                }
            }, _callee3, _this3);
        }));

        return function (_x3) {
            return _ref3.apply(this, arguments);
        };
    }();

    function request() {
        return { type: _constants.supportConstants.RESET_STATUS };
    }
}

function apidocsFromElasticAction(data) {
    var _this4 = this;

    var slug = data.slug;

    return function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch, apidocsFromElastic) {
            var cached;
            return _regenerator2.default.wrap(function _callee4$(_context4) {
                while (1) {
                    switch (_context4.prev = _context4.next) {
                        case 0:
                            cached = apidocsFromElastic[slug];

                            if (!cached) {
                                _context4.next = 3;
                                break;
                            }

                            return _context4.abrupt('return', dispatch(success(cached, true)));

                        case 3:
                            dispatch(request());

                            return _context4.abrupt('return', _services2.default.apidocsFromElastic(data).then(function (result) {
                                return dispatch(success(result));
                            }, function (error) {
                                return dispatch(failure(error));
                            }));

                        case 5:
                        case 'end':
                            return _context4.stop();
                    }
                }
            }, _callee4, _this4);
        }));

        return function (_x4, _x5) {
            return _ref4.apply(this, arguments);
        };
    }();

    function request() {
        (0, _utils.track)('apidocsFromElastic request', {});
        return { type: _constants.apidocsFromElasticConstants.REQUEST, slug: slug };
    }
    function success(response) {
        var silenced = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (!silenced) {
            (0, _utils.track)('apidocsFromElastic success', {});
        }
        return { type: _constants.apidocsFromElasticConstants.SUCCESS, response: response, slug: slug };
    }
    function failure(error) {
        (0, _utils.track)('apidocsFromElastic failure', {
            reason: error,
            slug: slug
        });
        return { type: _constants.apidocsFromElasticConstants.FAILURE, error: error, slug: slug };
    }
}

function providersFromAPIAction(_ref5) {
    var _this5 = this;

    var data = _ref5.providers,
        slug = _ref5.slug;

    return function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch) {
            return _regenerator2.default.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            dispatch(request());

                            return _context5.abrupt('return', _services2.default.providersFromAPI(data).then(function (result) {
                                return dispatch(success(result));
                            }, function (error) {
                                return dispatch(failure(error));
                            }));

                        case 2:
                        case 'end':
                            return _context5.stop();
                    }
                }
            }, _callee5, _this5);
        }));

        return function (_x7) {
            return _ref6.apply(this, arguments);
        };
    }();

    function request() {
        (0, _utils.track)('providersFromAPI request', { slug: slug });
        return { type: _constants.providersFromAPIConstants.REQUEST, slug: slug };
    }
    function success(response) {
        (0, _utils.track)('providersFromAPI success', { slug: slug });
        return { type: _constants.providersFromAPIConstants.SUCCESS, response: response, slug: slug };
    }
    function failure(error) {
        (0, _utils.track)('providersFromAPI failure', {
            reason: error,
            slug: slug
        });
        return { type: _constants.providersFromAPIConstants.FAILURE, error: error, slug: slug };
    }
}

function trackFailure(event, params, error) {
    var _error$response = error.response,
        response = _error$response === undefined ? {} : _error$response;
    var _response$data = response.data,
        data = _response$data === undefined ? {} : _response$data,
        status = response.status,
        statusText = response.statusText;
    var message = data.message;


    if (message) {
        params.message = message;
    } else {
        params.message = error;
    }
    (0, _utils.track)(event, _extends({}, params, { status: status, statusText: statusText }));
}

function getIntentProvidersAction(slug) {
    var _this6 = this;

    return function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch) {
            return _regenerator2.default.wrap(function _callee6$(_context6) {
                while (1) {
                    switch (_context6.prev = _context6.next) {
                        case 0:
                            dispatch(request());

                            return _context6.abrupt('return', _services2.default.getIntentProviders(slug).then(function (result) {
                                return dispatch(success(result));
                            }, function (error) {
                                return dispatch(failure(error));
                            }));

                        case 2:
                        case 'end':
                            return _context6.stop();
                    }
                }
            }, _callee6, _this6);
        }));

        return function (_x8) {
            return _ref7.apply(this, arguments);
        };
    }();

    function request() {
        return { type: _constants.getIntentProvidersConstants.REQUEST, slug: slug };
    }
    function success(response) {
        if (Array.isArray(response)) {
            return { type: _constants.getIntentProvidersConstants.SUCCESS, response: response, slug: slug };
        }
        var params = {
            request: 'getIntentProviders',
            message: 'success with unexpected data type',
            slug: slug
        };
        trackFailure('API failure', params, response);

        return {
            type: _constants.getIntentProvidersConstants.FAILURE,
            error: response,
            slug: slug
        };
    }
    function failure(error) {
        var params = {
            request: 'getIntentProviders',
            slug: slug
        };

        trackFailure('API failure', params, error);

        return { type: _constants.getIntentProvidersConstants.FAILURE, error: error, slug: slug };
    }
}

function getIntentLanguagesAction(slug) {
    var _this7 = this;

    return function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch) {
            return _regenerator2.default.wrap(function _callee7$(_context7) {
                while (1) {
                    switch (_context7.prev = _context7.next) {
                        case 0:
                            dispatch(request());

                            return _context7.abrupt('return', _services2.default.getIntentLanguages(slug).then(function (result) {
                                return dispatch(success(result));
                            }, function (error) {
                                return dispatch(failure(error));
                            }));

                        case 2:
                        case 'end':
                            return _context7.stop();
                    }
                }
            }, _callee7, _this7);
        }));

        return function (_x9) {
            return _ref8.apply(this, arguments);
        };
    }();

    function request() {
        return { type: _constants.getIntentLanguagesConstants.REQUEST, slug: slug };
    }
    function success(response) {
        return { type: _constants.getIntentLanguagesConstants.SUCCESS, response: response, slug: slug };
    }
    function failure(error) {
        var params = {
            request: 'getIntentLanguages',
            slug: slug
        };

        trackFailure('API failure', params, error);

        return { type: _constants.getIntentLanguagesConstants.FAILURE, error: error, slug: slug };
    }
}

function catalogSearchParamsAction(params) {
    return { type: _constants.catalogSearchConstants.CHANGE, params: params };
}

function catalogInlineSearchParamsAction(params) {
    return { type: _constants.catalogInlineSearchConstants.CHANGE, params: params };
}

function resetSearchParamsAction() {
    return { type: _constants.catalogSearchConstants.RESET };
}
function resetDemoParamsOnInputChange(params) {
    return { type: _constants.postRequestAPIConstants.RESET, data: params };
}

function requiresCustomAuth() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _data$provider = data.provider,
        provider = _data$provider === undefined ? {} : _data$provider,
        _data$keychain = data.keychain,
        keychain = _data$keychain === undefined ? {} : _data$keychain;
    var token = keychain.token;


    if (!token) {
        // all requests return cached result anyway
        return false;
    }

    if (!provider.integrated) {
        // not integrated providers will not work for any key - sandbox or production
        return true;
    }

    if (!provider.billable) {
        // if integrated but not billable -- probable means that such a provider requires own keys (a lot of examples for the sentiment intent) - sandbox or production
        return true;
    }

    if (!provider.stock_model) {
        // providers without a stock model require a custom model for sure
        return true;
    }
    // maybe provider.own_auth is important for this

    return false;
}

function isPremium() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _data$provider2 = data.provider,
        provider = _data$provider2 === undefined ? {} : _data$provider2,
        _data$keychain2 = data.keychain,
        keychain = _data$keychain2 === undefined ? {} : _data$keychain2;
    var token = keychain.token,
        production = keychain.production;

    if (production) {
        // all requests are paid by the user
        return false;
    }
    if (!token) {
        // all requests return cached result
        return false;
    }

    // modern MT is too expensive for the sandbox trial mode
    return provider.api_id === 'modernmt' || provider.api_id === 'modernmtrealtime';
}

function postRequestAPIAction() {
    var _this8 = this;

    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch) {
            var result, response;
            return _regenerator2.default.wrap(function _callee8$(_context8) {
                while (1) {
                    switch (_context8.prev = _context8.next) {
                        case 0:
                            dispatch(request());

                            if (!(isPremium(data) || requiresCustomAuth(data))) {
                                _context8.next = 4;
                                break;
                            }

                            result = {
                                response: {
                                    error: {
                                        code: 413,
                                        message: 'We do not route requests to these providers yet.'
                                    }
                                }
                            };
                            return _context8.abrupt('return', dispatch(failure(result)));

                        case 4:
                            _context8.prev = 4;
                            _context8.next = 7;
                            return _services2.default.postRequestAPI(data);

                        case 7:
                            response = _context8.sent;
                            return _context8.abrupt('return', dispatch(success(response)));

                        case 11:
                            _context8.prev = 11;
                            _context8.t0 = _context8['catch'](4);
                            return _context8.abrupt('return', dispatch(failure(_context8.t0)));

                        case 14:
                        case 'end':
                            return _context8.stop();
                    }
                }
            }, _callee8, _this8, [[4, 11]]);
        }));

        return function (_x13) {
            return _ref9.apply(this, arguments);
        };
    }();

    function request() {
        (0, _utils.track)('postRequestAPI request', {
            slug: data.slug
        });
        return { type: _constants.postRequestAPIConstants.REQUEST, data: data };
    }
    function success(response) {
        (0, _utils.track)('postRequestAPI success', {
            slug: data.slug
        });
        return { type: _constants.postRequestAPIConstants.SUCCESS, data: data, response: response };
    }
    function failure(error) {
        (0, _utils.track)('postRequestAPI failure', {
            reason: error,
            slug: data.slug
        });

        var params = {
            request: 'postRequestAPI',
            slug: data.slug
        };

        trackFailure('API failure', params, error);

        return { type: _constants.postRequestAPIConstants.FAILURE, data: data, error: error };
    }
}

function getNews() {
    var _this9 = this;

    return function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee9(dispatch) {
            var response;
            return _regenerator2.default.wrap(function _callee9$(_context9) {
                while (1) {
                    switch (_context9.prev = _context9.next) {
                        case 0:
                            dispatch(request());
                            _context9.prev = 1;
                            _context9.next = 4;
                            return _services2.default.getNews();

                        case 4:
                            response = _context9.sent;
                            return _context9.abrupt('return', dispatch(success(response)));

                        case 8:
                            _context9.prev = 8;
                            _context9.t0 = _context9['catch'](1);
                            return _context9.abrupt('return', dispatch(failure(_context9.t0)));

                        case 11:
                        case 'end':
                            return _context9.stop();
                    }
                }
            }, _callee9, _this9, [[1, 8]]);
        }));

        return function (_x14) {
            return _ref10.apply(this, arguments);
        };
    }();

    function request() {
        (0, _utils.track)('Medium API request request', {
            slug: 'medium news'
        });
        return { type: _constants.getNewsConstants.REQUEST };
    }
    function success(response) {
        (0, _utils.track)('Medium API request success', {
            slug: 'medium news'
        });
        return { type: _constants.getNewsConstants.SUCCESS, response: response };
    }
    function failure(error) {
        (0, _utils.track)('Medium API request failure', {
            reason: error,
            slug: 'medium news'
        });

        var params = {
            request: 'Medium API request',
            slug: 'medium news'
        };

        trackFailure('API failure', params, error);

        return { type: _constants.getNewsConstants.FAILURE, error: error };
    }
}

/***/ }),

/***/ 597:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(38);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var getResponse = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee(config, errorReportData) {
        var response;
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return (0, _axios2.default)(config);

                    case 3:
                        response = _context.sent;
                        return _context.abrupt('return', response.data);

                    case 7:
                        _context.prev = 7;
                        _context.t0 = _context['catch'](0);

                        (0, _utils.track)('service failure', errorReportData);
                        throw _context.t0;

                    case 11:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this, [[0, 7]]);
    }));

    return function getResponse(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

var support = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee2(data) {
        var requestOptions, url;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        requestOptions = getSignedRequestParams(data);
                        url = '/api/support';
                        return _context2.abrupt('return', getResponse(_extends({ url: url }, requestOptions), _extends({ url: url }, data)));

                    case 3:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function support(_x3) {
        return _ref2.apply(this, arguments);
    };
}();

var apidocsFromElastic = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee3(params) {
        var slug, data, requestOptions, url;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        slug = params.slug;
                        data = {
                            id: slug,
                            type: 'api'
                        };
                        requestOptions = getSignedRequestParams(data);
                        url = '/api/apidoc';
                        return _context3.abrupt('return', getResponse(_extends({ url: url }, requestOptions), { url: url, slug: slug }));

                    case 5:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function apidocsFromElastic(_x4) {
        return _ref3.apply(this, arguments);
    };
}();

var requestAPI = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee4(params, method) {
        var slug, data, url, apikey, production, logs, config, token, res;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        slug = params.slug, data = params.data;
                        url = 'https://' + INTENTO_API_HOST + '/' + slug;
                        apikey = INTENTO_API_KEY;
                        production = (0, _utils.getMarkedCookieValue)('IPK');
                        logs = {};


                        if (production) {
                            apikey = production;
                        }

                        config = {
                            url: url,
                            method: method,
                            headers: {
                                apikey: apikey,
                                'x-user-agent': _utils.APP_NAME + '/' + _utils.APP_VERSION
                            },
                            data: data
                        };
                        token = (0, _utils.getMarkedCookieValue)('UAT');


                        if (token && !production) {
                            config.url = INTENTO_CONSOLE_URL + '/api/' + slug;
                            config.headers.Authorization = 'Bearer ' + token;
                            delete config.headers['x-user-agent'];
                            delete config.headers.apikey;
                        }

                        if (data) {
                            try {
                                logs = {
                                    provider: data.service.provider,
                                    from: data.context.from,
                                    to: data.context.to
                                };
                            } catch (err) {} // eslint-disable-line no-empty
                        }

                        _context4.next = 12;
                        return getResponse(config, _extends({
                            url: url,
                            slug: slug,
                            isProduction: Boolean(production)
                        }, logs));

                    case 12:
                        res = _context4.sent;
                        return _context4.abrupt('return', res);

                    case 14:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function requestAPI(_x5, _x6) {
        return _ref4.apply(this, arguments);
    };
}();

var postRequestAPI = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee5(params) {
        return _regenerator2.default.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        return _context5.abrupt('return', requestAPI(params, 'POST'));

                    case 1:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function postRequestAPI(_x7) {
        return _ref5.apply(this, arguments);
    };
}();

var getRequestAPI = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee6(params) {
        return _regenerator2.default.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        return _context6.abrupt('return', requestAPI(params, 'GET'));

                    case 1:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function getRequestAPI(_x8) {
        return _ref6.apply(this, arguments);
    };
}();

var getProvider = function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee7(_ref8) {
        var intent = _ref8.intent,
            id = _ref8.id;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        return _context7.abrupt('return', getRequestAPI({ slug: intent + '/' + id }));

                    case 1:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, this);
    }));

    return function getProvider(_x9) {
        return _ref7.apply(this, arguments);
    };
}();

var getIntentProviders = function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee8(slug) {
        return _regenerator2.default.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        return _context8.abrupt('return', getRequestAPI({ slug: slug }));

                    case 1:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, this);
    }));

    return function getIntentProviders(_x10) {
        return _ref9.apply(this, arguments);
    };
}();

var getIntentLanguages = function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee9(intent) {
        return _regenerator2.default.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        return _context9.abrupt('return', getRequestAPI({ slug: intent + '/languages' }));

                    case 1:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, this);
    }));

    return function getIntentLanguages(_x11) {
        return _ref10.apply(this, arguments);
    };
}();

var providersFromAPI = function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee11(providers) {
        var _this = this;

        return _regenerator2.default.wrap(function _callee11$(_context11) {
            while (1) {
                switch (_context11.prev = _context11.next) {
                    case 0:
                        return _context11.abrupt('return', Promise.all(providers.map(function () {
                            var _ref12 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee10(p) {
                                var pFull;
                                return _regenerator2.default.wrap(function _callee10$(_context10) {
                                    while (1) {
                                        switch (_context10.prev = _context10.next) {
                                            case 0:
                                                _context10.next = 2;
                                                return getProvider(p);

                                            case 2:
                                                pFull = _context10.sent;
                                                return _context10.abrupt('return', _extends({ intent: p.intent }, pFull));

                                            case 4:
                                            case 'end':
                                                return _context10.stop();
                                        }
                                    }
                                }, _callee10, _this);
                            }));

                            return function (_x13) {
                                return _ref12.apply(this, arguments);
                            };
                        }())));

                    case 1:
                    case 'end':
                        return _context11.stop();
                }
            }
        }, _callee11, this);
    }));

    return function providersFromAPI(_x12) {
        return _ref11.apply(this, arguments);
    };
}();

var getNews = function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/_regenerator2.default.mark(function _callee12() {
        var response, data, res, posts;
        return _regenerator2.default.wrap(function _callee12$(_context12) {
            while (1) {
                switch (_context12.prev = _context12.next) {
                    case 0:
                        _context12.next = 2;
                        return (0, _axios2.default)('https://api.rss2json.com/v1/api.json?rss_url=https://blog.inten.to/feed');

                    case 2:
                        response = _context12.sent;
                        data = response.data || {};
                        // Filter for acctual posts. Comments don't have categories, therefore can filter for items with categories bigger than 0

                        res = data.items || []; // This is an array with the content. No feed, no info about author etc..

                        posts = res.filter(function (item) {
                            return item.categories.length > 0;
                        }); // That's the main trick* !

                        return _context12.abrupt('return', posts);

                    case 7:
                    case 'end':
                        return _context12.stop();
                }
            }
        }, _callee12, this);
    }));

    return function getNews() {
        return _ref13.apply(this, arguments);
    };
}();

var _axios = __webpack_require__(92);

var _axios2 = _interopRequireDefault(_axios);

var _utils = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* global INTENTO_API_HOST INTENTO_API_KEY INTENTO_CONSOLE_URL */


// for ie 11 for msoffice add-ins support
__webpack_require__(598).polyfill();

function getSignedRequestParams(data) {
    // TODO use middleware to sign each request

    var params = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Xsrftoken': (0, _utils.getCookieValue)('_xsrf') // TODO fix missing cookie
        }
    };

    if (process.env.REACT_APP_API_VERSION) {
        params.headers['X-api-version'] = process.env.REACT_APP_API_VERSION;
    }

    if (data) {
        params.data = data;
    }

    var token = localStorage.getItem('token');

    if (token) {
        params.headers.Authorization = 'Bearer ' + token;
    }

    return params;
}

exports.default = {
    support: support,
    postRequestAPI: postRequestAPI,
    apidocsFromElastic: apidocsFromElastic,
    getProvider: getProvider,
    getIntentProviders: getIntentProviders,
    getIntentLanguages: getIntentLanguages,
    providersFromAPI: providersFromAPI,
    getNews: getNews
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71)))

/***/ }),

/***/ 598:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    var then$$1 = void 0;
    try {
      then$$1 = value.then;
    } catch (error) {
      reject(promise, error);
      return;
    }
    handleMaybeThenable(promise, value, then$$1);
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = true;

  if (hasCallback) {
    try {
      value = callback(detail);
    } catch (e) {
      succeeded = false;
      error = e;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (succeeded === false) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = void 0;
      var error = void 0;
      var didError = false;
      try {
        _then = entry.then;
      } catch (e) {
        didError = true;
        error = e;
      }

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        if (didError) {
          reject(promise, error);
        } else {
          handleMaybeThenable(promise, entry, _then);
        }
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    if (isFunction(callback)) {
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    }

    return promise.then(callback, callback);
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));



//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(71), __webpack_require__(13)))

/***/ }),

/***/ 605:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LegacyMark = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LEGACY_PROVIDERS = ['ai.text.translate.sdl.language_cloud_translation_toolkit', 'ai.text.translate.sdl.enterprise_translation_server', 'sdlets', 'sdllanguagecloudtranslation'];

var LegacyMark = exports.LegacyMark = function LegacyMark(_ref) {
    var providerId = _ref.providerId;

    if (!LEGACY_PROVIDERS.includes(providerId)) {
        return null;
    }

    return _react2.default.createElement(
        'span',
        { className: 'try-intento__legacy-product-mark' },
        '(legacy product)'
    );
};

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(91);

var _utils = __webpack_require__(64);

var _LegacyMark = __webpack_require__(605);

var _SvgIcon = __webpack_require__(213);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProviderAsAPICard = function ProviderAsAPICard(_ref) {
    var provider = _ref.provider,
        noModels = _ref.noModels;
    var id = provider.id,
        api_id = provider.api_id,
        vendor = provider.vendor,
        description = provider.description,
        picture = provider.picture,
        showBolt = provider.showBolt;


    return _react2.default.createElement(
        'div',
        { className: 'api-cards__item' },
        _react2.default.createElement(
            'div',
            { className: 'api-card' },
            showBolt && _react2.default.createElement(
                'div',
                { className: 'api-card__badge', title: 'Integrated API' },
                _react2.default.createElement(_SvgIcon2.default, { slug: 'bolt' })
            ),
            _react2.default.createElement(
                _reactStatic.Link,
                {
                    className: 'api-card__link',
                    to: '/api-platform/api/' + api_id,
                    href: '/api-platform/api/' + api_id,
                    title: vendor,
                    onClick: (0, _utils.trackedClick)('API card provider clicked', {
                        source: 'Provider page',
                        title: api_id
                    })
                },
                _react2.default.createElement(
                    'div',
                    { className: 'api-card__image' },
                    _react2.default.createElement('img', {
                        style: { maxHeight: 120, maxWidth: 148 },
                        src: '/' + picture,
                        alt: 'Logo'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'api-card__content' },
                    _react2.default.createElement(
                        'h5',
                        { className: 'api-card__title' },
                        vendor,
                        ' ',
                        _react2.default.createElement(_LegacyMark.LegacyMark, { providerId: id })
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: 'api-card__text', title: description },
                        description
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'api-card__subtext' },
                        noModels ? '' : (0, _utils.countProviderModels)(provider)
                    )
                )
            )
        )
    );
};

exports.default = ProviderAsAPICard;

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Breadcrumbs = function Breadcrumbs(_ref) {
    var _ref$intent = _ref.intent,
        intent = _ref$intent === undefined ? '' : _ref$intent,
        long = _ref.long;

    var parts = [];
    if (intent.indexOf('/') !== -1) {
        parts = intent.split('/');
    } else {
        parts = intent.split('.');
    }

    var _parts$slice = parts.slice(1),
        _parts$slice2 = _slicedToArray(_parts$slice, 2),
        contentType = _parts$slice2[0],
        intentName = _parts$slice2[1];

    return _react2.default.createElement(
        'nav',
        { className: 'breadcrumbs' },
        long && _react2.default.createElement(
            'a',
            {
                className: 'breadcrumbs__link',
                href: '/api-platform',
                title: 'Intent Catalog'
            },
            'Intent\xA0Catalog'
        ),
        long && _react2.default.createElement(
            'span',
            { className: 'breadcrumbs__sep' },
            ' / '
        ),
        _react2.default.createElement(
            'a',
            { className: 'breadcrumbs__link', href: '/api-platform/ai', title: 'AI' },
            'AI'
        ),
        _react2.default.createElement(
            'span',
            { className: 'breadcrumbs__sep' },
            ' / '
        ),
        _react2.default.createElement(
            'a',
            {
                className: 'breadcrumbs__link',
                href: '/api-platform/ai/' + contentType,
                title: (0, _utils.capitalize)(contentType)
            },
            (0, _utils.capitalize)(contentType)
        ),
        _react2.default.createElement(
            'span',
            { className: 'breadcrumbs__sep' },
            ' / '
        ),
        _react2.default.createElement(
            'a',
            {
                className: 'breadcrumbs__link',
                href: '/api-platform/ai/' + contentType + '/' + intentName,
                title: (0, _utils.capitalize)(intentName)
            },
            (0, _utils.capitalize)(intentName)
        )
    );
};

exports.default = Breadcrumbs;

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(64);

var _SvgIcon = __webpack_require__(213);

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var linkTypeToIcon = {
    home: 'home',
    demo: 'home',
    legal: 'libra',
    signup: 'key',
    pricing: 'dollar',
    docs: 'book',
    hidden: 'book',
    code: 'cogwheel',
    spec: 'cogwheel',
    sdk: 'cogwheel',
    news: 'rss',
    discuss: 'rss'
};

var DocLink = function DocLink(_ref) {
    var type = _ref.type,
        url = _ref.url,
        title = _ref.title;
    return _react2.default.createElement(
        'li',
        { className: 'resource-links__item' },
        _react2.default.createElement(
            'a',
            {
                className: 'resource-links__item-link',
                href: url,
                title: title,
                onClick: (0, _utils.trackedClick)('API Links link clicked', {
                    source: 'API page',
                    title: title
                }),
                target: '_blank',
                rel: 'noopener noreferrer'
            },
            _react2.default.createElement(
                'span',
                { className: 'resource-links__item-icon' },
                _react2.default.createElement(_SvgIcon2.default, { slug: linkTypeToIcon[type] || type })
            ),
            title
        )
    );
};

exports.default = DocLink;

/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _HeroBase = __webpack_require__(593);

var _HeroBase2 = _interopRequireDefault(_HeroBase);

var _Breadcrumbs = __webpack_require__(667);

var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeroProvider = function HeroProvider(_ref) {
    var _ref$apidoc = _ref.apidoc,
        apidoc = _ref$apidoc === undefined ? {} : _ref$apidoc,
        _ref$intents = _ref.intents,
        intents = _ref$intents === undefined ? [] : _ref$intents;
    var _apidoc$vendor = apidoc.vendor,
        vendor = _apidoc$vendor === undefined ? '' : _apidoc$vendor,
        name = apidoc.name,
        version = apidoc.version;


    return _react2.default.createElement(
        _HeroBase2.default,
        { center: true },
        _react2.default.createElement(
            'div',
            { className: 'header__breadcrumbs' },
            intents.length < 1 && _react2.default.createElement(
                'span',
                null,
                '\xA0'
            ),
            intents.map(function (intent, idx) {
                return _react2.default.createElement(_Breadcrumbs2.default, { intent: intent, key: idx, long: true });
            })
        ),
        _react2.default.createElement(
            'h1',
            { className: 'hero__title h1' },
            vendor || _react2.default.createElement(
                'span',
                null,
                '\xA0'
            )
        ),
        _react2.default.createElement(
            'p',
            { className: 'hero__text' },
            name || _react2.default.createElement(
                'span',
                null,
                '\xA0'
            ),
            version && ' v' + version
        )
    );
};

exports.default = HeroProvider;

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(212);

var _reactStatic = __webpack_require__(91);

var _utils = __webpack_require__(64);

var _Breadcrumbs = __webpack_require__(667);

var _Breadcrumbs2 = _interopRequireDefault(_Breadcrumbs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CountFeature = function CountFeature(_ref) {
    var count = _ref.count,
        label = _ref.label;
    return _react2.default.createElement(
        'div',
        { className: 'numbers__item animate-appear' },
        _react2.default.createElement(
            'div',
            { className: 'numbers__value' },
            (0, _utils.formatNumberWithSpaces)(count)
        ),
        _react2.default.createElement(
            'div',
            { className: 'numbers__label' },
            label,
            count > 1 ? 's' : ''
        )
    );
};

function uniqueLen(list) {
    var unique = new Set(list || []);
    return unique.size;
}

var CountLanguages = function CountLanguages(_ref2) {
    var languages = _ref2.provider.languages;
    return _react2.default.createElement(
        'div',
        { className: 'doc__section' },
        _react2.default.createElement(
            'div',
            { className: 'doc__numbers' },
            _react2.default.createElement(
                'div',
                { className: 'numbers' },
                Boolean(languages) && _react2.default.createElement(
                    _react.Fragment,
                    null,
                    languages.symmetric && languages.symmetric.length > 0 && _react2.default.createElement(CountFeature, {
                        count: languages.symmetric.length,
                        label: 'language'
                    }),
                    languages.lang && languages.lang.length > 0 && _react2.default.createElement(CountFeature, {
                        count: languages.lang.length,
                        label: 'language'
                    }),
                    languages.pairs && languages.pairs.length > 0 && _react2.default.createElement(CountFeature, {
                        count: languages.pairs.length,
                        label: 'language pair'
                    }),
                    languages.language && languages.language.length > 0 && _react2.default.createElement(CountFeature, {
                        count: uniqueLen(languages.language),
                        label: 'language'
                    }),
                    languages.toscript && languages.toscript.length > 0 && _react2.default.createElement(CountFeature, {
                        count: uniqueLen(languages.toscript) * uniqueLen(languages.fromscript || []),
                        label: 'language pair'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'numbers__item' },
                    _react2.default.createElement(
                        'div',
                        { className: 'numbers__value' },
                        '1'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'numbers__label' },
                        'category'
                    )
                )
            )
        )
    );
};

var Capabilities = function Capabilities(_ref3) {
    var provider = _ref3.provider;
    return _react2.default.createElement(
        'div',
        { className: 'doc__section animate-appear' },
        _react2.default.createElement(
            'div',
            { className: 'doc__table table-wrapper' },
            _react2.default.createElement(
                'table',
                { className: 'doc-table table table--striped table--fixed-layout' },
                _react2.default.createElement(
                    'tbody',
                    null,
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'td',
                            null,
                            'Integrated'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            provider.integrated ? 'yes' : 'no'
                        )
                    ),
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'td',
                            null,
                            'Billing'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            provider.billable ? 'yes' : 'no'
                        )
                    ),
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'td',
                            null,
                            'Models'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            (0, _utils.countProviderModels)(provider, true)
                        )
                    ),
                    Boolean(provider.price) && _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'td',
                            null,
                            'Price'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            '$',
                            provider.price
                        )
                    ),
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'td',
                            null,
                            'HTML Support'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            (provider.format || []).indexOf('html') === -1 ? 'no' : 'yes'
                        )
                    ),
                    _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                            'td',
                            null,
                            'Bulk Mode'
                        ),
                        _react2.default.createElement(
                            'td',
                            null,
                            provider.bulk ? 'yes' : 'no'
                        )
                    )
                )
            )
        )
    );
};

var ProviderCapabilities = function ProviderCapabilities(_ref4) {
    var slug = _ref4.slug,
        providersFromAPI = _ref4.providersFromAPI,
        prefetchedIntents = _ref4.prefetchedIntents;

    var providersFullInfo = providersFromAPI[slug] || {};
    var pending = providersFullInfo.pending;

    var response = void 0;
    if (pending === false) {
        response = providersFullInfo.response || [];
    } else {
        response = prefetchedIntents;
    }
    var showHeader = response.length > 1;
    return response.map(function (provider, idx) {
        return _react2.default.createElement(
            _react.Fragment,
            { key: idx },
            showHeader && _react2.default.createElement(_Breadcrumbs2.default, { intent: provider.intent }),
            _react2.default.createElement(CountLanguages, { provider: provider }),
            _react2.default.createElement(Capabilities, { provider: provider })
        );
    });
};

function mapStateToProps(state) {
    return {
        providersFromAPI: state.providersFromAPI || {}
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _reactStatic.withRouteData)(ProviderCapabilities));

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LegacyInfo = undefined;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LEGACY_PROVIDERS = ['sdlets', 'sdllanguagecloudtranslation'];

var LegacyInfo = exports.LegacyInfo = function LegacyInfo(_ref) {
    var providerId = _ref.providerId;

    if (!LEGACY_PROVIDERS.includes(providerId)) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: 'doc__legacy-provider-wrapper' },
        _react2.default.createElement(
            'div',
            { className: 'doc__legacy-provider' },
            'This is a legacy product that may no longer be available from its vendor.'
        )
    );
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Provider.f1a8ef6f.js